<script>
  // export let message = "";
  export let style;
</script>


<div class="container" style={style}>
  <div class="spin"></div>
  <div class='x'>⨯</div>
</div>

 <style>
  .container {
    position: relative;
    width: 15px;
    height: 15px;
  }
  .x {
    top: 50%;
    left: 50%;
    position: absolute;
    transform: translate(-50%, -50%);
  }
  .spin {
    /* display: inline-block; */
    width: 12px;
    height: 12px;
    border: 3px solid rgba(255, 255, 255, .3);
    border-radius: 50%;
    border-top-color: #fff;
    animation: spin 1s ease-in-out infinite;
    -webkit-animation: spin 1s ease-in-out infinite;
    top: 50%;
    left: 50%;
    position: absolute;
    transform: translate(-50%, -50%);
  }
  @keyframes spin {
    to {
      transform: translate(-50%, -50%) rotate(360deg) ;
    }
  }
</style>
